export default "/images/22fad2831abc46b706fa17c5d70dc215.avif";